$.ajaxSetup({
  headers: {
    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
  },
  error: (jqXHR, textStatus, errorThrown) => {
    switch (jqXHR.status) {
      case 0:
        break;
      case 404:
        toastr.error('404 not found');
        break;
      case 419:
        toastr.error('CSRF token expired, please refresh the page');
        break;
      default:
        if (jqXHR.responseText) {
          toastr.error(`${
            jqXHR.responseText
          }`);
        } else {
          toastr.error(`Error: ${textStatus}: ${errorThrown}`);
        }
        break;
    }
  }
})

window.$$ = {};
window.$$.dt = require('./plugin_setting/datatable');
window.project = require('./project.js');

$.fn.select2.defaults.set("theme", 'bootstrap4');

$(() => {
  $('.select2ajax').select2({
    width: 'resolve',
    ajax: {
      dataType: 'json',
      delay: 500,
      processResults: (data) => { return { results: $.map(data.data, (obj) => { return { id: obj.value, text: obj.text }; }) } },
    },
    createTag: (params) => {
      var term = $.trim(params.term);
      return term === '' ? null : { id: term, text: `${term} (新增)` };
    },
  })
  $('.select2ajaxp').select2({
    width: 'resolve',
    ajax: {
      dataType: 'json',
      delay: 500,
      processResults: (data) => { return { results: $.map(data.data, (obj) => { return { id: obj.value, text: obj.text }; }), pagination: { more: (data.current_page * data.per_page) < data.total } } },
    },
    createTag: (params) => {
      var term = $.trim(params.term);
      return term === '' ? null : { id: term, text: `${term} (新增)` };
    },
  })
  $('.select2select').select2({ width: 'resolve' });
  $('.searchable-clear').on('click', (e) => { $(e.target).parents('.input-group-append').siblings('.searchable').val(null).trigger('change') });
  $('[data-toggle="tooltip"]').tooltip();
});